import {
  Component,
  Input,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ServiceDataUtilsService } from '@app/modules/service-data/services/service-data-utils.service';
import { GetServiceDataListAction } from '@app/modules/service-data/store/service-data.actions';
import { ServiceDataState } from '@app/modules/service-data/store/service-data.state';
import { ServiceData } from '@app/modules/service-data/types/service-data.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableActionType,
  DataTableActionsLocation,
  DataTableConfiguration,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { Observable, map, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-service-data-results',
  imports: [TranslateModule, DataTableComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './service-data-results.component.html',
})
export class ServiceDataResultsComponent implements OnInit {
  private dialogRef = inject(NgbActiveModal);
  private serviceDataUtilsService = inject(ServiceDataUtilsService);
  private store = inject(Store);
  private translateService = inject(TranslateService);

  @Input() public serviceDataIds: string[];

  protected dataTableConfiguration: DataTableConfiguration;
  protected isLoading = true;

  private rows$: Observable<ServiceData[]>;

  ngOnInit(): void {
    this.rows$ = this.store
      .dispatch(
        new GetServiceDataListAction(
          { ids: this.serviceDataIds },
          {},
          null,
          false
        )
      )
      .pipe(
        switchMap(() =>
          this.store.select(ServiceDataState.getServiceDatasByIds).pipe(
            map((getServiceDataByIds) =>
              getServiceDataByIds(this.serviceDataIds)
            ),
            tap(() => (this.isLoading = false))
          )
        )
      );

    this.dataTableConfiguration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      actionsLocation: DataTableActionsLocation.RIGHT,
      tableHeadClasses: '',
      actionsClasses: 'text-end',
      columns: [
        {
          label: 'serviceData.search.resultsTable.columns.referenceKey',
          property: 'referenceKey',
        },
        {
          label: 'serviceData.search.resultsTable.columns.name',
          invoke: {
            objectReference: {
              getFullName: (serviceData: ServiceData) =>
                `${serviceData.patientInformation.firstName} ${serviceData.patientInformation.lastName}`,
            },
            name: 'getFullName',
            args: [],
          },
        },
        {
          label: 'serviceData.search.resultsTable.columns.payerName',
          property: 'paymentInformation.notes',
        },
        {
          label: 'serviceData.search.resultsTable.columns.email',
          property: 'patientInformation.email',
        },
      ],
      singleActions: [
        {
          name: 'serviceData.search.resultsTable.actions.openDetails',
          icon: 'fa-light fa-file',
          type: DataTableActionType.BUTTON,
          action: this.openServiceDataDetails.bind(this),
        },
      ],
      rows$: this.rows$,
    };
  }

  private openServiceDataDetails(event: MouseEvent, serviceData: ServiceData) {
    this.serviceDataUtilsService.openDetails(serviceData.id);
    this.dismiss();
  }

  dismiss() {
    this.dialogRef.close();
  }
}
